import { render } from "./SendMailModal.vue?vue&type=template&id=6f8440e7"
import script from "./SendMailModal.vue?vue&type=script&lang=js"
export * from "./SendMailModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__